<template>
  <div class="sub-header d-none">
    <template v-if="!['deviceStatus', 'siteCreate'].includes(config)">
      <AreaChoice
        :areas="agencies"
        :selectedArea="selectedAgency"
        labelText="대리점 선택"
        placeholderText="대리점을 선택하세요"
        @change="$emit('agency-change', $event)"
      />

      <AreaChoice
        :areas="clients"
        :selectedArea="selectedClient"
        labelText="발주처 선택"
        placeholderText="발주처를 선택하세요"
        @change="$emit('client-change', $event)"
      />
    </template>
  </div>
</template>

<script>
import AreaChoice from '../common/AreaChoice.vue'

export default {
  name: 'SubHeaderBar',

  components: {
    AreaChoice,
  },

  props: {
    agencies: {
      type: Array,
      default: () => [],
    },
    clients: {
      type: Array,
      default: () => [],
    },
    selectedAgency: {
      type: Object,
      default: null,
    },
    selectedClient: {
      type: Object,
      default: null,
    },
    config: {
      type: String,
      default: '',
    },
  },

  emits: ['agency-change', 'client-change'],
}
</script>

<style scoped>
.sub-header {
  /* display: flex; */
  display: none;
  align-items: center;
  padding: 8px 20px;
  box-sizing: border-box;
}

.actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-input {
  display: flex;
  align-items: center;
  gap: 6px;

  height: 30px;
  padding: 0 10px;

  background-color: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: 8px;
}

.date-input .icon {
  font-size: 14px;
  color: var(--color-text-sub);
}

.date-input .flatpickr-input {
  width: 150px;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text-main);
  text-align: center;
  font-size: 12px;
}

.date-input:focus-within {
  border-color: var(--color-primary-border);
  box-shadow: 0 0 0 1px color-mix(in srgb,
      var(--color-primary) 35%,
      transparent);
}

.date-input .flatpickr-input::placeholder {
  color: var(--color-text-sub);
}

.tilde {
  font-weight: 600;
  color: var(--color-text-sub);
}

.actions button {
  height: 30px;
  padding: 0 14px;
  font-size: 12px;
  font-weight: 500;
  color: var(--color-text-main);
  background-color: var(--color-white);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.actions button:hover {
  background-color: var(--color-bg-hover);
}

.actions button.primary {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  color: var(--color-white);
}

.actions button.primary:hover {
  filter: brightness(0.95);
}

.actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>